import React from 'react';
import { Spin } from 'antd';

const Loading = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <Spin size="large" />
  </div>
);

export default Loading;